import { DataItemTypes, IDataItemDefinition } from '@zencity/reporting-types';
import {
  SurveysReportGeneratorDataItemKey,
  SurveysReportGeneratorFilterKey,
} from 'screens/WidgetGenerator/reportGeneratorComponents/enums';
import { withWidgetGeneratorContextForWidgets } from 'screens/WidgetGenerator/reportGeneratorComponents/components/WidgetWrappers/WidgetWrappers';
import {
  DataItemDefinitionGenerator,
  productSuffix,
  widgetLabels,
} from 'screens/WidgetGenerator/reportGeneratorComponents/dataItemDefinitions/helpers';
import { QuestionnaireHOC } from 'screens/WidgetGenerator/reportGeneratorComponents/components/QuestionnaireHOC/QuestionnaireHOC';

export const questionnaireDefinition = ({ products, clientData }: DataItemDefinitionGenerator): IDataItemDefinition[] =>
  products.map((product) => ({
    product,
    key: SurveysReportGeneratorDataItemKey.QUESTIONNAIRE,
    type: DataItemTypes.SINGLE_WIDGET,
    name: productSuffix(widgetLabels[SurveysReportGeneratorDataItemKey.QUESTIONNAIRE], product),
    description: 'Questionnaire',
    filters: [
      SurveysReportGeneratorFilterKey.CYCLES,
      SurveysReportGeneratorFilterKey.QUESTIONNAIRE_SURVEY_SINGLE_SELECT,
      SurveysReportGeneratorFilterKey.QUESTIONNAIRE_ASPECTS_SELECT,
      SurveysReportGeneratorFilterKey.QUESTIONNAIRE_TABLE_SPLIT_POSITION,
      SurveysReportGeneratorFilterKey.QUESTIONNAIRE_TABLE_TO_DISPLAY,
    ],
    component: withWidgetGeneratorContextForWidgets(
      QuestionnaireHOC,
      productSuffix(widgetLabels[SurveysReportGeneratorDataItemKey.QUESTIONNAIRE], product),
      clientData,
    ),
  }));
